<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
      {{ "bikeshop.shop_setup.card_headers.rental_time_configuration" | translate }}
</span>
    </div>
  </div>

  <div>


<div class="row" *ngIf="configuaration">
  <div class="col-md-12">
    <div class="content">
      <div class="row">
        <div class="col-md-12 section-header">
          {{ 'bikeshop.rentals.configuration.default_store_times' | translate }}
        </div>
      </div>

      <div class="row margin-top-8 data">
        <div class="col-md-3 row-header">{{'bikeshop.calendar.day' | translate}}</div>
        <div class="col-md-3 row-header">{{ 'bikeshop.rentals.configuration.is_open' | translate }}</div>
        <div class="col-md-3 row-header">{{ 'bikeshop.rentals.configuration.open_time' | translate }}</div>
        <div class="col-md-3 row-header">{{ 'bikeshop.rentals.configuration.close_time' | translate }}</div>
      </div>
      <div class="row margin-top-8 data" *ngFor="let day of configuaration.defaultStoreTimes">
        <div class="col-md-3 label">{{getDayLabel(day.dayOfWeek) | translate}}:</div>
        <div class="col-md-3">
          <p-inputSwitch [(ngModel)]="day.isWorking"></p-inputSwitch>
        </div>
        <div class="col-md-3">
          <p-calendar [ngClass]="{'invalid-time' : formatTime(day.startTime) > formatTime(day.endTime)}"
            [(ngModel)]="day.startTime" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly" [stepMinute]="5"
            [disabled]="!day.isWorking"></p-calendar>
        </div>
        <div class="col-md-3">
          <p-calendar [ngClass]="{'invalid-time' : formatTime(day.endTime) < formatTime(day.endTime)}"
            [(ngModel)]="day.endTime" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly" [stepMinute]="5"
            [disabled]="!day.isWorking"></p-calendar>
        </div>
      </div>

      <div class="row margin-top-16">
        <div class="col-md-9"></div>
        <div class="col-md-3">
          <button class="iso-round-button full-width" (click)="updateDefaultStoreHours()" [disabled]="updatingDefaultStoreTimes">{{
            'bikeshop.rentals.configuration.update_store_times' | translate
            }}</button>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="row" style="padding-bottom: 94px" *ngIf="configuaration">
  <div class="col-md-6">
    <div class="content margin-top-16">
      <app-rental-override-store-times [configuration]="configuaration"></app-rental-override-store-times>
    </div>
  </div>
  <div class="col-md-6">
    <div class="content margin-top-16">
      <app-rental-custom-pickup-slots [configuration]="configuaration"></app-rental-custom-pickup-slots>
    </div>
  </div>
</div>
<p-toast position="bottom-right"></p-toast>
